import { getPreference } from '@openclassrooms/utils/config';

export const APPLE_COLOR = '#000000';
export const APPLE_LIB_URL =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

export function getAppleConfig() {
  return {
    color: APPLE_COLOR,
    clientId: getPreference('apple')?.appId,
    libUrl: APPLE_LIB_URL,
  };
}
